import { usePopups } from '@mm-frontend/mm-web-ui-kit';
import PopupAdultConfirm from './PopupAdultConfirm.vue';

const { createPopup } = usePopups();
const popupAdultConfirm = createPopup({ component: PopupAdultConfirm });

export function usePopupAdultConfirm() {
  return { showPopupAdultConfirm: () => popupAdultConfirm.show() };
}
